var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('BackTop',{attrs:{"height":500,"bottom":100}},[_c('Icon',{staticClass:"top",attrs:{"type":"md-arrow-round-up"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }